import { useLang } from 'hooks/lang';

import { Modal } from 'components/Blocks';

import { RecruitmentModalProvider } from './requestRecruitment.context';
import { SampleForm } from './SampleForm';

import { TaskOptionOverlayProps } from '../createTaskOptions';

export function RequestRecruitmentModal({ close, isOpen, ...props }: TaskOptionOverlayProps) {
  const { t } = useLang();

  return (
    <RecruitmentModalProvider close={close} {...props}>
      <Modal
        isOpen={isOpen}
        close={close}
        title={t('request-recruitment')!}
        width="min(90vw, 660px)"
        className="overflow-auto"
      >
        <SampleForm />
      </Modal>
    </RecruitmentModalProvider>
  );
}
